import { InjectionToken } from '@angular/core';

export const ENTITY_ACTION_SUCCESS_HANDLER = new InjectionToken<
  (action: string) => void
>('ENTITY_ACTION_SUCCESS_HANDLER');
